import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  fetchFacilitiesStatus,
  type FacilitiesStatusInput,
} from '../api/fetch-facilities-status.api';
import {
  fetchFacilityById,
  type FacilityByIdInput,
} from '../api/fetch-facility-by-id.api';
import type { ApiError } from '@/utils/types';

export const getFacilitiesStatus = createAsyncThunk(
  'ProductionReporting/getFacilitiesStatus',
  async (params: FacilitiesStatusInput, thunkAPI) => {
    try {
      // Call API to get facilities status
      return await fetchFacilitiesStatus(params);
    } catch (e: unknown) {
      return thunkAPI.rejectWithValue(
        (e as ApiError).message || 'Failed to fetch facilities with status'
      );
    }
  }
);

export const getFacilityById = createAsyncThunk(
  'ProductionReporting/getFacilityById',
  async (params: FacilityByIdInput, thunkAPI) => {
    try {
      // Call API to get facility by ID
      return await fetchFacilityById(params);
    } catch (e: unknown) {
      return thunkAPI.rejectWithValue(
        (e as ApiError).message || 'Failed to fetch facility by ID'
      );
    }
  }
);
